export const APPENDIX_SECTION_TAGS_WITH_PLATFORM = [
  'list-of-platforms',
  'supported-platform-and-api-in-awc-platform',
  'promotionType-id',
  'parameter-combination-to-enter-specified-table',
  'gameTable-id',
  'platforms-regional-ip-restriction',
  'refPlatformTxId-value-definition',
]

/** 頂層 section 的 parentSectionId，須與後端 ApiDoc_Sections_new 一致 */
export const PARENT_SECTION_ROOT = 'ROOT'

/** 是否為根層父節點（DB 已統一為 ROOT；仍相容記憶體中未帶欄位的情況） */
export const isRootParentSectionId = pid => pid === PARENT_SECTION_ROOT || pid === undefined || pid === null || pid === ''
